const heroData = {
	title: 'Luxury Wishlist for Freelancers',
	subtitle:
		'Harrods Hampers gifted by PayPal + Amazon shoppers.',
	btnText: 'Claim free wishlist',
	heroImageDesktop: require('./desktop-hero.jpg'),
	heroImageMobile: require('./mobile-hero.jpg'),
	btnLink: 'https://www.69work.com/marketplace/register',
};

export default heroData;
